export enum BookingPaymentStatus {
    PENDING = 'pending',
    CONFIRMED = 'confirmed',
    FAILED = 'failed',
    CANCELLED = 'cancelled',
    NOT_PAID = 'not_paid',
    PAID = 'paid',
    PARTIALLY_PAID = 'partially_paid'
}

export enum BookingSource {
    WEBSITE = 'website',
    BACKOFFICE = 'backoffice',
    DOOR = 'door',
    HOTEL = 'hotel',
    WHATSAPP = 'whatsapp',
    GROUP_TOUR_LEADER = 'group_tour_leader',
    AGENCY = 'agency',
    PLATFORM_VIATOR = 'platform_viator',
    PLATFORM_GETYOURGUIDE = 'platform_getyourguide',
    PLATFORM_TICKETS = 'platform_tickets',
    PLATFORM_AIRBNB = 'platform_airbnb',
    OTHER_PLATFORM = 'other_platform',
    OTHER_SOURCE = 'other_source'
}

export enum BookingType {
    STANDARD = 'standard',
    VIP = 'vip'
}

export interface Booking {
    _id?: string;
    short_id: string;
    show_id: string;
    seat_ids: string[];
    booked_adult_seats: number;
    booked_children_seats: number;
    booked_total_seats: number;
    booking_type: BookingType;
    customer_name: string;
    customer_email: string;
    customer_phone: string;
    booking_date: Date;
    created_by: string;
    created_source: BookingSource | string;
    language_code: string;
    total_price: number;
    payment_status: BookingPaymentStatus;
    generated_payment_link?: string;
    payment_type?: string;
    transaction_id?: string;
    payment_order_code?: string;
    booking_created_at?: Date;
    booking_updated_at?: Date;
    check_in_token?: string;
    is_checked_in?: boolean;
    check_in_date?: Date;
    notes?: string;
    booking_from_public_website?: boolean;
}